<template>
    <div>

        <TextBanner>
        Zum ersten Mal seit 50 Jahren soll die <b>Artemis-Mission</b> wieder Menschen auf den Mond bringen. Dafür wird eine orbitale Raumstation gebaut: das <b>Gateway</b>. Allerdings soll es auf dem Mond auch eine Basisstation geben. <p></p>
        Finden Sie die Erde und erfahren Sie, wie der Transport ins All funktioniert. 
        </TextBanner>

        <InfoBox modalName="IB_Artemis">
            <template #title>Artemis: Ein internationales Forschungsprojekt</template>
            <template #subline></template>
            <template>

                <!-- Bild -->
                <figure>
                    <img class="img-fluid" src="../assets/img/020_logo.jpg" alt="">
                    <figcaption>
                        <div class="legal">&copy; Nasa</div>
                        Das Emblem der Artemis-Mission.
                    </figcaption>
                </figure>

                <p>Die Artemis-Mission wird von der amerikanischen Weltraumbehörde Nasa geleitet, allerdings steht dahinter eine internationale Kooperation verschiedener Raumfahrtagenturen – genau wie bei der internationalen Raumstation ISS. Im März 2019 fiel der Startschuss und die Nasa hoffte, dass schon fünf Jahre später Menschen auf dem Mond landen können. 
                Doch die Vorarbeiten dauern länger als geplant, und so wird es wohl frühestens 2026 so weit sein.</p>


                                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/020_artemis.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="314" data-height="314" v-lazy="require('../assets/img/020_artemis_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Interfoto</div>
                            Artemis - Göttin des Mondes und der Jagd.
                        </figcaption>
                    </figure>
                </FullscreenImage>
                
                <p>Artemis ist die Zwillingsschwester des Mondgottes Apollon – 
                    also die Mondgöttin. Mehr als 50 Jahre nach den erfolgreichen Apollo-Missionen trägt das Programm damit einen weiblichen Namen.</p>
               



            </template>
        </InfoBox>


        <InfoBox modalName="IB_Gateway">
            <template #title>Gateway - eine neue internationale Raumstation</template>
            <template #subline></template>
            <template>

                 <p>Die orbitale Station am Mond dient als <b>Beobachtungsposten und Hightech-Labor</b>.</p> 
                <p>Sie umkreist den Mond auf einer elliptischen Umlaufbahn in nord-südlicher Richtung. An ihrem mondnächsten Punkt ist sie etwa 4.000 Kilometer von der Mondoberfläche entfernt. Am fernsten Punkt rund 75.000 Kilometer.</p>
            </template>
        </InfoBox>

        <InfoBox modalName="IB_SLS">
            <template #title>So kommt die Station ins All</template>
            <template #subline></template>
            <template>
                <p>Grundlage für den Transport ist das neue <b>Space Launch System, kurz SLS</b>. Das Schwerlast-Raketensystem soll in der Lage sein, große Teile in eine Umlaufbahn des Mondes zu befördern. Die Entwicklung des SLS läuft bereits seit mehr als einem Jahrzehnt. 
                    Es basiert auf dem 2011 eingestellten Spaceshuttle-Programm.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/030_sls.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="640" data-height="360" v-lazy="require('../assets/img/030_sls_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                            Das Space Launch System (SLS) ist ein flexibles Schwerlastraketensystem.
                        </figcaption>
                    </figure>
                </FullscreenImage>

            </template>
        </InfoBox>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('TolleInfoBox')"></div>
        </Fallback>


    </div>
</template>

<script>

    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                //moveFunction: 'move',
                radiusLimits: [1.5,150],  
                position: [0.39,1.17,1.5],   //0.3,1.6,2
                target: [0,-0.16,-0.02],   //0,-0.1,0.02
                animationSpeed: 800,  //800

                //fov: .8,
                useAutoRotationBehavior: true,
                idleRotationSpeed: -0.008,   //0.002   -0.008
            },

            artemis_geo:{

                Station_All:{
                    Empty:{
                        Orion:{
                        visible: false,
                                // Label_Orion:{
                                //     fade: false,
                                //     visible: false,
                                //     billboardMode: 7,
                                //     }
                                }
                            }
                        },

                Erde_Plane:{
                    fade: true,
                    pickable: false,
                    visible: true,
                    scaling: [0.5,0.5,0.5]
                    },

                Sonne: {
                    fade: true,
                    visible: true
                    },

                Weltall: {                            
                    fade: false,
                    visible: true,
                    },

                Mars :{                           
                    fade: true,
                    visible: false
                    },

                Schatten_Mars: {
                    fade: true,
                    visible: false,
                    },

                Schatten_Mond: {
                    fade: true,
                    visible: false,
                    },

                Label_Gateway: {
                    Text_Gateway:{
                        renderingGroupId: 1
                    },

                    visible: true,
                    renderingGroupId:1,
                    billboardMode: 7
                },
                },

            hotspots: {
                info_4a: {
                    visible: true,
                    infoBox: 'IB_Gateway',
                    //renderingGroupId: 1,
                    position: [0,-.12,-.01],
                    scale: .15,
                },

                info_4b: {
                    visible: true,
                    infoBox: 'IB_Artemis',
                    //renderingGroupId: 1,
                    position: [-3.2,-.15,-2],
                    scale: .6,
                },

                Info_5: {
                    visible: true,
                    infoBox:'IB_SLS',
                    //renderingGroupId: 1,
                    position: [-55,2,-170],   //am Halo Modul -1, 2.5, -1    -900, 10,-2500  scale 800
                    scale: 20,                     //2.5
                },

            },
           
        },
        babylonReady: function () {

        // this.$babylonController.timer.add(5400, () => {
        //     this.$babylonController.setCameraRadiusLimit(2,150);
        // });

        // this.$babylonController.goToAnimation("anim_orion_ankommen", 0);
        // this.$babylonController.startAnimation("anim_orion_ankommen", false, .1);


        this.$babylonController.goToAnimation("anim_power", 0);
        this.$babylonController.goToAnimation("anim_lander", 0);
        this.$babylonController.goToAnimation("anim_canadarm", 0);
        this.$babylonController.goToAnimation("anim_logistics", 0);
        this.$babylonController.goToAnimation("anim_habitation", 0);
        this.$babylonController.goToAnimation("anim_orion", 0);
        this.$babylonController.goToAnimation("anim_esprit", 0);
        this.$babylonController.goToAnimation("anim_halo", 0);
        this.$babylonController.goToAnimation("anim_airlock", 0);

        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
